"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExecutionStateValueProvider = void 0;
var _SourceProviders = _interopRequireDefault(require("../source/SourceProviders"));
var _data = require("../data");
/**
 * Provides values for dumbapp UI and execution based on ExecutionState.
 */

class ExecutionStateValueProvider {
  constructor(currentState, providers = _SourceProviders.default) {
    this.currentState = currentState;
    this.providers = providers;
  }
  set state(state) {
    this.currentState = state;
  }
  get state() {
    return this.currentState;
  }
  get dumbapp() {
    var _this$currentState;
    return (_this$currentState = this.currentState) === null || _this$currentState === void 0 ? void 0 : _this$currentState.dumbapp;
  }
  getAccount() {
    var _this$currentState2, _this$currentState2$w;
    return (_this$currentState2 = this.currentState) === null || _this$currentState2 === void 0 ? void 0 : (_this$currentState2$w = _this$currentState2.wallet) === null || _this$currentState2$w === void 0 ? void 0 : _this$currentState2$w.account;
  }
  getArgValue(arg, step, argNum) {
    return this.getSourceValue(arg.value, arg, step);
  }
  getInput(name, typing) {
    if (this.currentState) {
      for (let values of this.currentState.data) {
        if (values.data[name] !== undefined) {
          switch (values.type) {
            case "query":
              return (0, _data.queryDataToValue)(values.data[name], typing);
            case "form":
              return (0, _data.formDataToValue)(values.data[name], typing);
            default:
              return values.data[name];
          }
        }
      }
    }
    return undefined;
  }
  getSourceValue(source, arg, step) {
    return this.providers.valueForSource(this, source, arg, step);
  }
  combineInputs() {
    let data = {};
    if (this.currentState) {
      for (let values of this.currentState.data) {
        switch (values.type) {
          case "query":
            for (let [key, value] of Object.entries(values.data)) {
              if (value !== undefined) {
                data[key] = (0, _data.queryDataToValue)(value);
              }
            }
            break;
          case "form":
            for (let [key, value] of Object.entries(values.data)) {
              if (value !== undefined) {
                data[key] = (0, _data.formDataToValue)(value);
              }
            }
            break;
          default:
            for (let [key, value] of Object.entries(values.data)) {
              if (value !== undefined) {
                data[key] = value;
              }
            }
            break;
        }
      }
    }
    return data;
  }
}
exports.ExecutionStateValueProvider = ExecutionStateValueProvider;
//# sourceMappingURL=ExecutionStateValueProvider.js.map